import { useState } from "react";

/**
 * A company email design rendered in a sandboxed iframe (2026-10-27). `scale` shrinks it into
 * a thumbnail: the email is laid out at its real 640px width and scaled down, so a thumbnail
 * looks like the mail rather than a squashed copy. Without `scale` it grows to its content.
 */
const WIDTH = 640;

const WidgetFrame = ({ html, title, scale, height = 220, style }) => {
  const [contentHeight, setContentHeight] = useState(null);
  const onLoad = (e) => {
    const doc = e.target.contentDocument;
    if (doc?.body) setContentHeight(doc.body.scrollHeight + 16);
  };

  if (scale) {
    return (
      <div style={{ width: WIDTH * scale, height, overflow: "hidden", borderRadius: 8, border: "1px solid #e5e7eb", background: "#eef0f7", pointerEvents: "none", ...style }}>
        <iframe title={title} srcDoc={html} sandbox="allow-same-origin" tabIndex={-1}
          style={{ width: WIDTH, height: height / scale, border: "none", transform: `scale(${scale})`, transformOrigin: "0 0" }} />
      </div>
    );
  }
  return (
    <iframe title={title} srcDoc={html} sandbox="allow-same-origin" onLoad={onLoad}
      style={{ width: "100%", height: contentHeight || 480, border: "none", display: "block", background: "#eef0f7", ...style }} />
  );
};

export default WidgetFrame;
